import { getRequest } from "../request";
import { BASVURU_SILINEN_ISLEM_KAYDINI_GETIR } from "../constants/requestUrls";

const BasvuruSilinenIslemKaydiniGetir = (basvuruId) => {
    return getRequest({url:BASVURU_SILINEN_ISLEM_KAYDINI_GETIR + '?basvuruId=' + basvuruId});
}

export default BasvuruSilinenIslemKaydiniGetir;